import ExamItemWrapper from './ExamItemWrapper';

export default ExamItemWrapper;
